import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  TextField,
  DialogActions,
  Divider,
  MenuItem,
} from "@material-ui/core";
import { LclDataContext } from "../../Contexts/LclDataContext";
import ButtonUpload from "../ButtonUpload";
import ButtonEdit from "../ButtonEdit";
import UploadFileSection from "../UploadFileSection";

const EditDpc = (props) => {
  const { truckId, itemData, week, day, itemId, ...otherProps } = props;
  const { createLclModel, comments } = useContext(LclDataContext);
  const lclModel = createLclModel({ week });
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const displayColumns = [
    "eventTimeString",
    "conNoteNum",
    "eventType",
    "branch",
    "sender",
    "location",
    "zone",
    "receiver",
    "eventAddress",
    "eventItems",
    "kg",
    "m3",
    "dpc",
    "stopPay",
    "homeDelivery",
    "totalDPC",
    "reason",
    comments,
  ];

  const enabledColumns = [
    "location",
    "zone",
    "eventItems",
    "kg",
    "m3",
    "dpc",
    "homeDelivery",
    "stopPay",
    "reason",
    comments,
  ];
  // const disabledColumns = ["eventAddress", "conNoteNum", "sender", "receiver"];

  const reasons = [
    "Missing StopPay",
    "Duplicate StopPay",
    "Incorrect Suburb",
    "Load rate",
    "Incorrect DPC rate",
    "Incorrect number of Items",
    "Incorrect M3",
    "Incorrect Weight",
    "Other",
  ];

  const [formData, setFormData] = useState({
    values: {
      ...displayColumns.reduce(
        (acc, cur) => ({ ...acc, [cur]: itemData[cur] }),
        {}
      ),
    },
    valid: {},
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      values: { ...formData.values, [name]: value },
    });
  };

  useEffect(() => {
    setFormData({
      ...formData,
      valid: {
        ...Object.keys(formData.values).reduce(
          (acc, cur) => ({
            ...acc,
            [cur]: lclModel[cur].validate(formData.values),
          }),
          {}
        ),
      },
    });
    // setFormData({
    //   ...formData,
    //   valid: {
    //     ...Object.keys(formData.values).reduce((acc, cur) => {
    //       console.log(cur);
    //       return { ...acc, [cur]: lclModel[cur].validate(formData.values) };
    //     }, {}),
    //   },
    // });
  }, [formData.values]);

  const deleteFile = (fileName) => {
    setFiles(files.filter((file) => file.name !== fileName));
  };

  return (
    <Dialog {...otherProps} fullWidth maxWidth="sm">
      <DialogTitle>Edit LCL Item</DialogTitle>
      <DialogContent>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          spacing={1}
        >
          {displayColumns.map((col) => (
            <React.Fragment key={col}>
              <Grid item xs={3}>
                {lclModel[col].displayName}:
              </Grid>
              <Grid item xs={9}>
                <TextField
                  fullWidth
                  value={formData.values[col]}
                  onChange={(event) => handleChange(event)}
                  error={!formData.valid[col]}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...lclModel[col].textFieldProps}
                  {...(col === "reason" && {
                    children: reasons.map((e) => (
                      <MenuItem key={e} value={e}>
                        {e}
                      </MenuItem>
                    )),
                  })}
                  disabled={loading || !enabledColumns.includes(col)}
                />
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </DialogContent>
      <Divider />
      <UploadFileSection files={files} setFiles={setFiles} />
      <Divider />
      <DialogActions>
        <ButtonUpload
          disabled={loading}
          color="primary"
          variant="contained"
          maxFileSize={10000000}
          accept={[".png", ".jpg", ".pdf", ".docx", ".xlsx", ".csv"]}
          multiple={false}
          files={files}
          setFiles={setFiles}
        >
          Browse
        </ButtonUpload>
        <ButtonEdit
          disabled={loading || Object.values(formData.valid).includes(false)}
          variant="contained"
          color="primary"
          controller="lcls"
          truckId={truckId}
          week={week}
          day={day}
          itemId={itemId}
          itemData={{
            ...itemData,
            ...formData.values,
            kg: Number(formData.values.kg),
            m3: Number(formData.values.m3),
            dpc: Number(formData.values.dpc),
            stopPay: Number(formData.values.stopPay),
            homeDelivery: Number(formData.values.homeDelivery),
            // eventItems: Number(formData.values.eventItems),
            driver: Number(truckId),
            truck: Number(truckId),
          }}
          files={files}
          callback={props.onClose}
        />
      </DialogActions>
    </Dialog>
  );
};

export default EditDpc;

EditDpc.propTypes = {
  truckId: PropTypes.number.isRequired,
  itemData: PropTypes.object.isRequired,
  week: PropTypes.number.isRequired,
  day: PropTypes.number.isRequired,
  itemId: PropTypes.string.isRequired,
};
